import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { RemoteConfigService } from '../core/services/remote-config.service';
import { AuthService } from '../core/services/auth.service';
import { LoadingService } from '../core/services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {
  constructor(
    private remoteConfigService: RemoteConfigService,
    private authService: AuthService,
    private loadingService: LoadingService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    this.loadingService.show();
    try {
      const isMaintenance = await this.remoteConfigService.getMaintenanceAdmin();
      if (isMaintenance) {
        this.authService.logout();
        return this.router.parseUrl('/maintenance');
      }
      return true;
    } finally {
      this.loadingService.hide();
    }
  }
} 